import { QRCode } from "react-qrcode-logo";
import { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";

export default function QRCodeCanvasWrapper({
  secretId,
  eventName,
  displaySize = 200,   // rozmiar widocznego QR w UI
  exportSize = 1600,   // rozdzielczość pliku PNG (np. 1600x1600)
}) {
  const [isHovered, setHover] = useState(false);
  // Refs not strictly needed for canvas selection if we use IDs, but keeping structure
  const smallRef = useRef(null);
  const bigRef = useRef(null);

  const guestRegisterURL = `${window.location.origin}/guestRegister/${secretId}`;

  const downloadPNG = () => {
    // react-qrcode-logo nadaje ID bezpośrednio elementowi canvas
    const bigCanvas = document.getElementById("qr-code-export");
    if (!bigCanvas) {
      console.error("Canvas element #qr-code-export not found");
      return;
    }

    const pngUrl = bigCanvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");

    const a = document.createElement("a");
    a.href = pngUrl;
    a.download = `qr-${eventName || "event"}-${exportSize}px.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(guestRegisterURL);
      // Opcjonalnie: można dodać toast/powiadomienie
      // alert("Link skopiowany do schowka ✅"); 
    } catch (err) {
      console.error("Błąd kopiowania linku:", err);
    }
  };

  return (
    <div className="admin-box qr-box d-flex flex-column gap-3">
      <h5 className="fw-bold m-0 text-secondary">Udostępnij link gościom</h5>

      <div className="d-flex flex-column align-items-center gap-3">
        {/* Widoczny mały QR - TYLKO ON ma białą ramkę */}
        <div
          ref={smallRef}
          onClick={downloadPNG}
          className="cursor-pointer transition-transform hover-scale bg-white shadow-sm p-3 rounded-4"
          title="Kliknij, aby pobrać PNG w wysokiej rozdzielczości"
          style={{ transition: 'transform 0.2s, box-shadow 0.2s', cursor: 'pointer' }}
        >
          <QRCode
            value={guestRegisterURL}
            size={displaySize}
            qrStyle="dots"
            eyeRadius={10}
            bgColor="#ffffff"
            fgColor="#000000" // Black color
            quietZone={10}
            id="qr-code-display"
          />
        </div>

        {/* Ukryty duży QR do eksportu */}
        <div
          ref={bigRef}
          style={{
            position: "absolute",
            left: "-10000px",
            top: 0,
            pointerEvents: "none",
            opacity: 0,
          }}
          aria-hidden="true"
        >
          <QRCode
            value={guestRegisterURL}
            size={exportSize}
            qrStyle="dots"
            eyeRadius={40}
            bgColor="#ffffff"
            fgColor="#000000" // Black color
            quietZone={50}
            id="qr-code-export"
          />
        </div>

        {/* Interaktywny kafelek z linkiem */}
        <div
          className="w-75 bg-white shadow-sm rounded-4 p-2 mb-3 cursor-pointer position-relative overflow-hidden hover-lift d-flex align-items-center justify-content-center"
          onClick={copyToClipboard}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          title="Kliknij, aby skopiować link"
          style={{ height: '50px', transition: 'all 0.2s ease', cursor: 'pointer' }}
        >
          {/* Widok domyślny: Link */}
          <div
            className={`position-absolute w-100 h-100 d-flex align-items-center justify-content-center transition-opacity ${isHovered ? "opacity-0" : "opacity-100"
              }`}
            style={{ transition: "opacity 0.2s" }}
          >
            <p className="m-0 text-primary fw-bold text-truncate px-3" style={{ fontSize: '0.9rem', maxWidth: '100%' }}>
              {guestRegisterURL.replace(/^https?:\/\//, '')}
            </p>
          </div>

          {/* Widok hover: Napis "Kopiuj" */}
          <div
            className={`position-absolute w-100 h-100 d-flex align-items-center justify-content-center gap-2 bg-light transition-opacity ${isHovered ? "opacity-100" : "opacity-0"
              }`}
            style={{ transition: "opacity 0.2s" }}
          >
            <FontAwesomeIcon icon={faCopy} className="text-dark" />
            <span className="fw-bold text-dark small">Kliknij, aby skopiować</span>
          </div>
        </div>
      </div>

      <style>{`
        .hover-scale:hover { transform: scale(1.05); }
        .hover-lift:hover { transform: translateY(-2px); box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important; }
      `}</style>
    </div >
  );
}
